import { render, staticRenderFns } from "./ResalesAdd.vue?vue&type=template&id=05668564&scoped=true"
import script from "./ResalesAdd.vue?vue&type=script&lang=js"
export * from "./ResalesAdd.vue?vue&type=script&lang=js"
import style0 from "./ResalesAdd.vue?vue&type=style&index=0&id=05668564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05668564",
  null
  
)

export default component.exports